// ===== Store Links =====
export const playStoreLink = 'https://play.google.com/store/apps/details?id=com.eero.android';
export const appStoreLink = 'https://apps.apple.com/us/app/eero-home-wifi-system/id1023499075';

export const playStoreTMobileLink = 'https://play.google.com/store/apps/details?id=com.eero.tmobile.fiber';
export const appStoreTMobileLink = 'https://apps.apple.com/us/app/t-mobile-fiber-eero/id6752574293';

// ===== eero App Links =====
export const applinksInvitesEeroLink = 'https://applinks.eero.com/invites/index.html'
export const applinksInvitesE2roLink = 'https://applinks.e2ro.com/invites/index.html'

export const applinksMyNewEeroLink = 'https://applinks.eero.com/my-new-eero/index.html'
export const applinksMyNewE2roLink = 'https://applinks.e2ro.com/my-new-eero/index.html'

export const applinksAppLink = 'https://applinks.eero.com/app'
export const applinksAppE2roLink = 'https://applinks.e2ro.com/app'

export const applinksAddOrReplaceDeviceLink = 'https://applinks.eero.com/addorreplacedevice'
export const applinksAddOrReplaceDeviceE2roLink = 'https://applinks.e2ro.com/addorreplacedevice'

export const applinksKilimanjaroLink = 'https://applinks.eero.com/kmj'
export const applinksKilimanjaroE2roLink = 'https://applinks.e2ro.com/kmj'

export const applinksPlusPurchaseCompleteLink = 'https://applinks.eero.com/pluspurchasecomplete'
export const applinksPlusPurchaseCompleteE2roLink = 'https://applinks.e2ro.com/pluspurchasecomplete'

export const applinksSubscriptionReferralLink = 'https://applinks.eero.com/subscriptionreferral'
export const applinksSubscriptionReferralE2roLink = 'https://applinks.e2ro.com/subscriptionreferral'

// ===== T-Mobile App Links =====
export const applinksInvitesEeroTMobileLink = 'https://applinks.eero.com/tmobile/invites/index.html'
export const applinksInvitesE2roTMobileLink = 'https://applinks.e2ro.com/tmobile/invites/index.html'

export const applinksMyNewEeroTMobileLink = 'https://applinks.eero.com/tmobile/my-new-eero/index.html'
export const applinksMyNewE2roTMobileLink = 'https://applinks.e2ro.com/tmobile/my-new-eero/index.html'

export const applinksAppTMobileLink = 'https://applinks.eero.com/tmobile/app'
export const applinksAppE2roTMobileLink = 'https://applinks.e2ro.com/tmobile/app'

export const applinksAddOrReplaceDeviceTMobileLink = 'https://applinks.eero.com/tmobile/addorreplacedevice'
export const applinksAddOrReplaceDeviceE2roTMobileLink = 'https://applinks.e2ro.com/tmobile/addorreplacedevice'

export const applinksKilimanjaroTMobileLink = 'https://applinks.eero.com/tmobile/kmj'
export const applinksKilimanjaroE2roTMobileLink = 'https://applinks.e2ro.com/tmobile/kmj'

const appUrls = {
    playStoreLink,
    appStoreLink,
    playStoreTMobileLink,
    appStoreTMobileLink,
    applinksInvitesEeroLink,
    applinksInvitesE2roLink,
    applinksInvitesEeroTMobileLink,
    applinksInvitesE2roTMobileLink,
    applinksMyNewEeroLink,
    applinksMyNewE2roLink,
    applinksMyNewEeroTMobileLink,
    applinksMyNewE2roTMobileLink,
    applinksAppLink,
    applinksAppE2roLink,
    applinksAppTMobileLink,
    applinksAppE2roTMobileLink,
    applinksAddOrReplaceDeviceLink,
    applinksAddOrReplaceDeviceE2roLink,
    applinksAddOrReplaceDeviceTMobileLink,
    applinksAddOrReplaceDeviceE2roTMobileLink,
    applinksKilimanjaroLink,
    applinksKilimanjaroE2roLink,
    applinksKilimanjaroTMobileLink,
    applinksKilimanjaroE2roTMobileLink,
    applinksPlusPurchaseCompleteLink,
    applinksPlusPurchaseCompleteE2roLink,
    applinksSubscriptionReferralLink,
    applinksSubscriptionReferralE2roLink
};

export default appUrls;
